import { render, staticRenderFns } from "./RegistrationFormManagement.vue?vue&type=template&id=07d42b55&"
import script from "./RegistrationFormManagement.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormManagement.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports